import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { noiEndPoints, powerRevenueEndPoints } from "../../../../services/apiEndPoints";
import { currencyFormatter } from "../../../../services";
import { getData } from "../../../../services/api";

import { Icon } from "../../../../components/base";
import { COLORS } from "../../../../theme/colors";

import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import NOIIcon from "../../../../assets/images/power-revenues/noi-increase.svg";
import PowerRevenuesIcon from "../../../../assets/images/power-revenues/power-revenue.svg";
import AveragePowerRevenueIcon from "../../../../assets/images/power-revenues/average-power-revenue.svg";
import { Parameters } from "./Parameters";
import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";
import { sliders } from "./sample";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: `${theme.spacing(3.5)}px 0 ${theme.spacing(3)}px`,
  },
  titleUppercase: {
    textTransform: "uppercase",
    fontWeight: 700,
  },
  titleSpan: {
    fontStyle: "italic",
    textTransform: "capitalize",
    color: COLORS.darks[0][50],
  },
  infoBox: {
    padding: `45px 0`,
    marginLeft: theme.spacing(3),
    display: "flex",
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(0, 0, 0, .25)",
    },
  },
  infoBoxIcon: {
    width: 62,
    height: 62,
    marginRight: 10,
  },
  price: {
    fontSize: 24,
    fontWeight: 700,
  },
  box: {
    margin: `2px ${theme.spacing(1.5)}px ${theme.spacing(3.25)}px`,
  },
}));

export const SensitivityAnalysisTab = () => {
  const classes = useStyles();
  const [sensitivityParameter, setSensitivityParameter] = useState(
    JSON.parse(JSON.stringify(sliders))
  );
  const [isSliderTriggered, setSliderTrigger] = useState(false);
  const [data, setData] = useState({
    averagePowerRevenue: 0,
    averageNoiIncrease: 0,
    totalPowerRevenue: 0,
  });
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  useEffect(() => {
    const dateQueryParams = {
      period,
      startDate,
      endDate,
    };
    getData(noiEndPoints.SENSITIVITY_INITIALS, setSensitivityValues, dateQueryParams);
  }, [period, startDate, endDate]);

  useEffect(() => {
    if (isSliderTriggered) {
      getPowerRevenue(JSON.parse(JSON.stringify(sensitivityParameter)));
      setSliderTrigger(false);
    }
  }, [isSliderTriggered]);

  const setSensitivityValues = (value) => {
    const temp = [...JSON.parse(JSON.stringify(sensitivityParameter))];

    const updatedData = temp.map((params) => {
      if (!value[params.key]) return params;
      return {
        ...params,
        value: value[params.key].toFixed(0),
        defaultValue: value[params.key].toFixed(0),
      };
    });
    const parametersValues = JSON.parse(JSON.stringify(updatedData));
    setSensitivityParameter(parametersValues);
    getPowerRevenue(parametersValues);
  };

  const getPowerRevenue = (parameters) => {
    const payload = {};
    parameters.map((val) => {
      payload[val.key] = +val.value;
    });
    const {
      sold_electricity_margin,
      purchased_electricity_margin,
      digitalization_impact,
      gas_prices,
    } = payload;

    const dateQueryParams = {
      sold_electricity_margin,
      purchased_electricity_margin,
      praas_ai: digitalization_impact,
      gas_prices,
      period,
      startDate,
      endDate,
    };
    getData(
      powerRevenueEndPoints.SENSITIVITY_ANALYSIS,
      ({ average_power_revenue, average_noi_increase, total_power_revenue }) => {
        setData((prev) => {
          return {
            ...prev,
            averagePowerRevenue: average_power_revenue,
            averageNoiIncrease: average_noi_increase,
            totalPowerRevenue: total_power_revenue,
          };
        });
      },
      dateQueryParams
    );
  };
  return (
    <Box>
      <Grid container alignItems="center" justifyContent="space-between" className={classes.title}>
        <Typography className={classes.titleUppercase}>
          Sensitivity Analysis -{" "}
          <Typography component="span" className={classes.titleSpan}>
            Edit Filters To View Potential Revenues Changes
          </Typography>
        </Typography>
      </Grid>
      <ShaDowBox>
        <Grid container>
          <Grid item sm={4}>
            <Parameters
              data={sensitivityParameter}
              setData={setSensitivityParameter}
              setSliderTrigger={setSliderTrigger}
            />
          </Grid>
          <Grid item sm={3} style={{ borderLeft: "1px solid rgba(0, 0, 0, .25)" }}>
            <Box className={classes.infoBox}>
              <Box className={classes.infoBoxIcon}>
                <Icon src={AveragePowerRevenueIcon} />
              </Box>
              <Box>
                <Typography>Average Power Revenue/Y</Typography>
                <Typography className={classes.price}>
                  {currencyFormatter(data.averagePowerRevenue, currencySymbol)}
                </Typography>
              </Box>
            </Box>
            <Box className={classes.infoBox}>
              <Box className={classes.infoBoxIcon}>
                <Icon src={NOIIcon} />
              </Box>
              <Box>
                <Typography>Average NOI Increase/Y</Typography>
                <Typography className={classes.price}>
                  {currencyFormatter(data.averageNoiIncrease, currencySymbol)}
                </Typography>
              </Box>
            </Box>
            <Box className={classes.infoBox}>
              <Box className={classes.infoBoxIcon}>
                <Icon src={PowerRevenuesIcon} />
              </Box>
              <Box>
                <Typography>Total Power Revenues - 20Y</Typography>
                <Typography className={classes.price}>
                  {currencyFormatter(data.totalPowerRevenue, currencySymbol)}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item sm={5}>
            <Box className={classes.box}>
              <ActionTimeGroup
                period={period}
                startDate={startDate}
                endDate={endDate}
                hideShareBtn
                hideExportBtn
                hideIntegrateBtn
                hideTimeRange
              />
            </Box>
          </Grid>
        </Grid>
      </ShaDowBox>
    </Box>
  );
};
